<template>
  <transition name="tooltip-fade">
    <div
      v-if="visible"
      class="custom-tooltip"
      :style="tooltipStyle"
      @mouseenter="onEnter"
      @mouseleave="onLeave"
    >
      <component
        v-if="content"
        :is="content.component"
        v-bind="content.props"
      />
      <slot v-else>{{ contentText }}</slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: "TreeTableTooltip",
  props: {
    visible: Boolean,
    content: Object,
    contentText: String,
    tooltipStyle: Object,
  },
  inject: ["tooltipApi"],
  methods: {
    onEnter() {
      this.tooltipApi.enterTooltip();
    },
    onLeave() {
      this.tooltipApi.leaveTooltip();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variables.less";
.custom-tooltip {
  position: fixed;
  border-radius: @br;
  padding: 4px 8px;
  max-width: 300px;
  letter-spacing: 0.3px;
  color: #ffffff;
  background-color: fade(@text-color-light, 90%);
  // pointer-events: auto;
  z-index: 999;
}
.tooltip-fade-enter-active,
.tooltip-fade-leave-active {
  transition: opacity 0.2s ease;
}
.tooltip-fade-enter,
.tooltip-fade-leave-to {
  opacity: 0;
}
.tooltip-fade-enter-to,
.tooltip-fade-leave {
  opacity: 1;
}
</style>
